import humanizeMinutes from 'Common/utils/humanizeMinutes';

export const getDropoffMessageCopy = (dropoffDeltaDays: number) => {
  if (dropoffDeltaDays > 0) {
    const formattedDuration = humanizeMinutes(dropoffDeltaDays * 24 * 60);
    const durationCopy = `Drop-off in ${formattedDuration}`;

    return durationCopy;
  }
};
